<template>
<li class="tbody" :style="isPrint ? {gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr'} : {}">
  <!-- checkbox -->
  <span v-if="!isPrint" class="p-4 border-right" style="background-color: #f9f9f9;">
    <vs-checkbox v-model="form.is_checked" class="w-full" @change="handleChangeChecked" :disabled="readonly"></vs-checkbox>
  </span>

  <!-- 구분(공정설비 장소 등) -->
  <span class="p-4 border-right" style="align-items: start">
    <span v-if="isPrint">{{ form.구분 }}</span>
    <vs-input v-else @change="changeText" v-model="form.구분" :readonly="readonly" />
  </span>

  <!-- 유해·위험요인 -->
  <span class="p-4 border-right" style="align-items: start">
    <span v-if="isPrint">{{ form.위험요인 }}</span>
    <vs-textarea v-else class="m-0" v-model="form.위험요인" @change="changeText" :readonly="readonly"></vs-textarea>
  </span>

  <!-- 재해형태 -->
  <span class="p-4 border-right" style="align-items: start">
    <span v-if="isPrint">{{ getDisaster(form.disaster) }}</span>
    <disaster-type-selector v-else class="w-full" v-model="form.disaster" :readonly="readonly"/>
  </span>

  <!-- 현재 안전조치 -->
  <span class="p-4 border-right" style="align-items: start">
    <span v-if="isPrint">{{ form.안전조치 }}</span>
    <vs-textarea v-else class="m-0" v-model="form.안전조치" @change="changeText" :readonly="readonly"></vs-textarea>
  </span>

  <!-- 현재 위험성 추정 및 결정: 가능성 -->
  <div class="p-0 border-right" style="height: 100%; display: grid; grid-template-columns: 1fr 1fr 2fr;">
    <div class="w-full py-4 px-2">
      <span v-if="isPrint">{{ form.현재가능성 }}</span>
      <number-selector v-else class="w-full" :last="3" v-model="form.현재가능성" @change="()=>{changeSelect('현재')}" :readonly="readonly"/>
    </div>

    <div class="w-full py-4 px-2">
      <span v-if="isPrint">{{ form.현재중대성 }}</span>
      <number-selector v-else class="w-full" :last="3" v-model="form.현재중대성" @change="()=>{changeSelect('현재')}" :readonly="readonly"/>
    </div>

    <div class="w-full py-4 px-2 border-left">
      <span v-if="isPrint">{{ form.현재위험도 }}</span>
      <vs-input class="w-full" v-else v-model="form.현재위험도"  @change="()=>{changeSelect('현재')}" :readonly="readonly"/>
    </div>
  </div>

  <!-- 위험성 감소대책 -->
  <span class="p-4 border-right" style="align-items: start">
    <span v-if="isPrint">{{ form.위험성감소대책 }}</span>
    <vs-textarea v-else class="m-0" v-model="form.위험성감소대책" @change="changeText" :readonly="readonly"></vs-textarea>
  </span>

  <!-- 개선후 위험성 추정 및 결정 -->
  <div class="p-0 border-right" style="height: 100%; display: grid; grid-template-columns: 1fr 1fr 2fr;">
    <div class="w-full py-4 px-2">
      <span v-if="isPrint">{{ form.개선후가능성 }}</span>
      <number-selector v-else class="w-full" :last="3" v-model="form.개선후가능성" @change="()=>{changeSelect('개선후')}" :readonly="readonly"/>
    </div>

    <div class="w-full py-4 px-2">
      <span v-if="isPrint">{{ form.개선후중대성 }}</span>
      <number-selector v-else class="w-full" :last="3" v-model="form.개선후중대성" @change="()=>{changeSelect('개선후')}" :readonly="readonly"/>
    </div>

    <div class="w-full py-4 px-2 border-left">
      <span v-if="isPrint">{{ form.개선후위험도 }}</span>
      <vs-input class="w-full" v-else v-model="form.개선후위험도"  @change="()=>{changeSelect('개선후')}" :readonly="readonly"/>
    </div>
  </div>

</li>
</template>

<script>
import WarningLvSelector from '@/views/components/WarningLvSelector'
import DisasterTypeSelector from '@/views/components/DisasterTypeSelector'
import MemberSelector from '@/views/components/MemberSelector'
import AutoCompletionTextField from '@/views/components/AutoCompletionTextField'
import RatingClassificationSelector from '@/views/components/RatingClassificationSelector'
import NumberSelector from '@/views/components/NumberSelector'
export default {
  name: 'RiskAssessmentEvalTableList2',
  components: {
    NumberSelector,
    RatingClassificationSelector,
    AutoCompletionTextField,
    MemberSelector,
    DisasterTypeSelector,
    WarningLvSelector},
  props:{
    value:Object,
    readonly:Boolean,
    useManager:Boolean,
    oneHead:Boolean,
    isPrint:Boolean,
    warningLvList: {
      type: Array,
      default: () => [
        {text:'A', value:'A'},
        {text:'B', value:'B'},
        {text:'C', value:'C'}
      ]
    }
  },
  watch:{
    value (data) {
      this.form = data
    }
  },
  computed: {
    memberAll () {
      const memberAll = []
      for (const member of this.$store.state.project.projectUserList) {
        memberAll.push({text:member.name, value:member.id})
      }
      return memberAll
    }
  },
  data () {
    return {
      form:{
        is_checked:false,
        구분: '',
        위험요인: '',
        disaster: '', // 재해형태
        안전조치: '',
        현재가능성: '',
        현재중대성: '',
        현재위험도: '',
        위험성감소대책: '',
        개선후가능성: '',
        개선후중대성: '',
        개선후위험도: ''
      }
    }
  },
  created () {
    this.form = this.value
  },
  methods:{
    handleChangeChecked () {
      this.$emit('handleChangeChecked', this.form)
    },
    changeText () {
      this.$emit('input', this.form)
    },
    changeSelect (type) {

      if (type === '현재') {
        const point = parseInt(this.form.현재가능성) + parseInt(this.form.현재중대성)
        if (point >= 6) {
          this.form.현재위험도 = `${point}(높음)`
        } else if (point >= 3) {
          this.form.현재위험도 = `${point}(보통)`
        } else {
          this.form.현재위험도 = `${point}(낮음)`
        }
      } else if (type === '개선후') {
        const point = parseInt(this.form.개선후가능성) + parseInt(this.form.개선후중대성)
        if (point >= 6) {
          this.form.개선후위험도 = `${point}(높음)`
        } else if (point >= 3) {
          this.form.개선후위험도 = `${point}(보통)`
        } else {
          this.form.개선후위험도 = `${point}(낮음)`
        }
      }

      this.$emit('input', this.form)
    },

    getEvalClass (value) {
      if (value === 'mechanical') return '기계적 요인'
      if (value === 'electrical') return '전기적 요인'
      if (value === 'chemical') return '화학 물질적'
      if (value === 'work_characteristics') return '작업 특성적 요인'
      if (value === 'work_environment') return '작업 환경적 요인'
    },

    getDisaster (value) {
      value = value ? parseInt(value) : 0
      if (value === 1) return '감염'
      if (value === 2) return '감전'
      if (value === 3) return '교통사고'
      if (value === 4) return '깔림'
      if (value === 5) return '끼임'
      if (value === 6) return '낙하'
      if (value === 7) return '넘어짐'
      if (value === 8) return '뒤집힘'
      if (value === 9) return '떨어짐'
      if (value === 10) return '맞음'
      if (value === 11) return '무너짐'
      if (value === 12) return '근골격계질환'
      if (value === 14) return '베임'
      if (value === 15) return '붕괴'
      if (value === 16) return '빠짐'
      if (value === 17) return '(산소)결핍'
      if (value === 18) return '소음노출'
      if (value === 19) return '아차사고'
      if (value === 20) return '이상기압 노출, 접촉'
      if (value === 21) return '익사'
      if (value === 22) return '유해광선 노출'
      if (value === 23) return '절단'
      if (value === 24) return '중독'
      if (value === 25) return '질식'
      if (value === 26) return '질환'
      if (value === 27) return '찔림'
      if (value === 28) return '충돌'
      if (value === 29) return '탈락'
      if (value === 30) return '파열'
      if (value === 31) return '폭발'
      if (value === 32) return '화재'
      if (value === 33) return '화학물질 누출 접촉'
      if (value === 34) return '기타'
    }

  }
}
</script>

<style >
[dir] ul.table li textarea {
  height: 108px;
  resize: none;
}
</style>
